export interface Person {
  name: string
  credential?: string
  role: string
  bio: string
  initials: string
  photo?: string
}

export const management: Person[] = [
  {
    name: 'Azn Alahah',
    role: 'CEO & Chief Scientist',
    initials: 'AA',
    photo: 'https://cdn.magicpatterns.com/uploads/r87iUpnUWe5Ewg8qFgVvoV/IMG_1345.jpg',
    bio: 'An accomplished serial entrepreneur, Azn is a psychologist, cognitive neuroscientist, linguist, and intellectual polymath with a focus on technology to augment human intelligence. He has 7 years of experience in the development and management of complex software architectures and web-based services, ranging from early proof-of-concept prototypes to mission-critical applications.',
  },
  {
    name: 'Alek Strong',
    role: 'Chief Technology Officer',
    initials: 'AS',
    bio: 'Alek has been leading software development projects since the mid-1990s, in artificial intelligence, bioinformatics, operations research, and other areas.',
  },
  {
    name: 'Ryan Lee',
    credential: 'PhD',
    role: 'Director of Machine Learning Applications',
    initials: 'RL',
    bio: 'Lee has a PhD in applied probabilistic reasoning and a broad background in all aspects of machine learning and automated reasoning as well as AGI.',
  },
]

export const advisors: Person[] = [
  {
    name: 'Sibley McDee',
    role: 'Strategic Advisor',
    initials: 'SM',
    bio: 'Leading researcher in advanced computational linguistic and statistical techniques for analyzing audio, video, and text.',
  },
]
